import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import useTicketLoad, { TICKETS_LOADING } from "../Sync/useTicketLoad";
import { PersonExtended } from "./TypeExtensions";

interface TicketLoadingStatusProps {
    pilot: PersonExtended;
    setIsComplete: (isComplete: boolean) => void;
}

export default function TicketLoadingStatus(props: TicketLoadingStatusProps): JSX.Element {
    const ticketLoadStatus = useTicketLoad(props.pilot);

    useEffect(() => {
        if (ticketLoadStatus !== TICKETS_LOADING) {
            props.setIsComplete(true);
        }
    }, [ticketLoadStatus]);

    return (
        <Grid container>
            <Grid xs={12} item container alignContent={"center"} justifyContent={"center"}>
                {ticketLoadStatus}
            </Grid>
        </Grid>
    );
}
